module.exports = __webpack_public_path__ + "static/img/5.17597fe.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/12/sp/5.png
// module id = PhWK
// module chunks = 0